import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import TranslationValue from './TranslationValue';
import { TLCode } from '../../../common/enums';

// @ts-ignore
interface TranslatedMessage extends FormattedMessage.Props {
  id: TLCode;
  children?: (formattedMessage: string) => React.ReactNode;
}

const TranslatedMessage = (props: TranslatedMessage) => {
  const { id, ...otherProps } = props;

  // @ts-ignore
  return <TranslationValue code={id}>{(value) => <FormattedMessage id={value} {...otherProps} />}</TranslationValue>;
};

export default TranslatedMessage;
